import { Link } from 'react-router-dom';
import { featuredSpreadsheets } from '@/mocks/categories';

export default function FeatureGridSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Top Verified Mulebuy Spreadsheet Resources
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">2026 Updated List</p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="py-3 px-4 font-semibold text-foreground-800 whitespace-nowrap">Spreadsheet Name</th>
                <th className="py-3 px-4 font-semibold text-foreground-800 whitespace-nowrap">Update Frequency</th>
                <th className="py-3 px-4 font-semibold text-foreground-800 whitespace-nowrap">Reliability</th>
                <th className="py-3 px-4 font-semibold text-foreground-800 whitespace-nowrap">Features</th>
                <th className="py-3 px-4 font-semibold text-foreground-800 whitespace-nowrap">Best For</th>
              </tr>
            </thead>
            <tbody>
              {featuredSpreadsheets.map((sheet, idx) => (
                <tr key={idx} className="border-b border-background-200 hover:bg-background-100 transition-colors">
                  <td className="py-3.5 px-4 font-medium text-foreground-900">{sheet.name}</td>
                  <td className="py-3.5 px-4 text-foreground-700">{sheet.frequency}</td>
                  <td className="py-3.5 px-4">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                      sheet.reliability === 'High' ? 'bg-primary-100 text-primary-800' : 'bg-secondary-100 text-secondary-800'
                    }`}>
                      {sheet.reliability}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-foreground-700">{sheet.features}</td>
                  <td className="py-3.5 px-4 text-foreground-700">{sheet.bestFor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-background-100 rounded-xl p-6 md:p-8">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-5">
              <i className="ri-file-list-3-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">What is Mulebuy Spreadsheet</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              A <strong>mulebuy spreadsheet</strong> is a structured data file used to track, organize, and compare products, agents, and sourcing options within the Mulebuy ecosystem. It helps users compare different buying agents, track product availability, and analyze pricing trends.
            </p>
            <Link to="/article/mulebuy-spreadsheet-guide" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer inline-flex items-center gap-1">
              Read Full Guide <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-8">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-5">
              <i className="ri-scales-3-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">Agent Comparison Tools</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              Compare different Mulebuy agents side by side using structured spreadsheet data. Evaluate pricing, shipping times, reliability scores, and user reviews to find the best agent for your sourcing needs.
            </p>
            <Link to="/article/mulebuy-agent-comparison" className="text-sm font-medium text-accent-600 hover:text-accent-700 cursor-pointer inline-flex items-center gap-1">
              Compare Agents <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-8">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-5">
              <i className="ri-refresh-line text-xl text-secondary-700"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">2026 Updated Lists</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              Access the most current <strong>mulebuy spreadsheet lists</strong> updated regularly for 2026. Stay ahead with real-time data synchronization, verified agent information, and the latest product availability across all categories.
            </p>
            <Link to="/article/mulebuy-spreadsheet-list-2026" className="text-sm font-medium text-foreground-800 hover:text-foreground-950 cursor-pointer inline-flex items-center gap-1">
              View Lists <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}